export const EXTERNAL_DATA_SOURCE_LINK_STATE = {
    notApplicable: 0,
    unlinked: 1,
    linkedAndNotUnlinkable: 2,
    linkedAndUnlinkable: 3
};

export const EXTERNAL_COLUMN_TYPES = {
    0: "Unknown",
    1: "Integer",
    2: "Decimal",
    11: "AbsoluteUrl",
    12: "RelativeUrl",
    21: "Boolean",
    50: "Email",
    100: "String"
};
